module.exports = __webpack_public_path__ + "static/media/perfil.fc699b91.svg";